<template>
  <a-card :bordered="false" style="width: 60%">
  <a-divider orientation="left">
    <b>关于我们</b>
  </a-divider>
  <a-form-model ref="form" :model="form" :rules="rules" style="width: 400px">
    <a-form-model-item label="公司名称" prop="companyName" >
      <a-input v-model="form.companyName" placeholder="请输入公司名称" />
    </a-form-model-item>
    <a-form-model-item label="备案号" prop="icp" >
      <a-input v-model="form.icp" placeholder="请输入备案号" />
    </a-form-model-item>
    <a-form-model-item label="工信部网站" prop="url" >
      <a-input v-model="form.url" placeholder="请输入工信部网站" />
    </a-form-model-item>
    <a-form-model-item label="证照信息" prop="certificate" >
      <file-upload type="image" :defaultList="form.certificateArr" :count="6"
                   @input="getImg($event, 'certificate')"></file-upload>
    </a-form-model-item>
    <a-form-model-item label="工作时间" prop="workTime" >
      <a-input v-model="form.workTime" placeholder="请输入工作时间" />
    </a-form-model-item>
    <a-form-model-item label="联系电话" prop="mobile" >
      <a-input v-model="form.mobile" placeholder="请输入工信部网站" />
    </a-form-model-item>
    <div class="bottom-control">
      <a-space>
        <a-button type="primary" :loading="submitLoading" @click="submitForm">
          保存
        </a-button>
        <a-button type="dashed" @click="cancel">
          取消
        </a-button>
      </a-space>
    </div>
  </a-form-model>
  </a-card>
</template>

<script>
import { getAboutUs, addAboutUs, updateAboutUs } from '@/api/aboutUs/aboutUs'
import {guid} from "@/utils/ruoyi";
import { processImageUrl } from '@/utils/util'
export default {
  name: 'AboutUs',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        companyName: null,
        icp: null,
        url: null,
        mobile: null,
        workTime: null,
        certificate: null,
        certificateCount:6,
        certificateArr:[],
        createTime: null,
        remark: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        companyName: [
          { required: true, message: '公司名称不能为空', trigger: 'blur' }
        ],
        icp: [
          { required: true, message: '备案号不能为空', trigger: 'blur' }
        ],
        url: [
          { required: true, message: '工信部网站不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
    this.handleInfo()
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },

    /**上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info', info)
      if (info.length === 0) {
        this.form[fieldName] = ''
        this.form[`${fieldName}Arr`] = []
      } else {
        if (this.form[`${fieldName}Count`] === 1) {
          this.form[fieldName] = info[0].halfUrl
          this.form[`${fieldName}Arr`] = info
        } else {
          this.form[fieldName] = info.map(ele => { return ele.halfUrl }).join(",")
          this.form[`${fieldName}Arr`] = info
        }
      }
    },


    // 表单重置
    reset () {

      this.form = {
        id: null,
        companyName: null,
        icp: null,
        url: null,
        mobile: null,
        workTime: null,
        certificate: null,
        certificateCount:6,
        certificateArr:[],
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },


    handleInfo () {
      this.reset()
      getAboutUs().then(response => {
        this.form = response.data
        if(this.form.certificate){
          let that = this
          this.form.certificateArr = []
          this.form.certificate.split(",").forEach(item => {
            that.form.certificateArr.push({
              uid: guid(8, 10),
              name: item,
              status: 'done',
              halfUrl: item,
              url: processImageUrl(item),
              path: item
            })
          })
        }
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateAboutUs(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              // this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addAboutUs(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              // this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
              this.handleInfo()
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
